import { Spinner } from "@opero/ui";

export function ProvisioningProgress() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center space-y-4">
      <Spinner size="lg" />
      <p className="text-sm text-slate-500 dark:text-slate-400">
        Setting up your workspace…
      </p>
    </div>
  );
}
